module.exports = __webpack_public_path__ + "img/icon1.796b520a.png";